import React from 'react';
import UploadManager from 'components/UploadManager';

const PricePatchUploads = () =>
  <UploadManager
    uploadType="price_patch_uploads"
    title="Price Patch"
  />;

export default PricePatchUploads;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/pricePatchUploads/index.jsx